import React from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";

class GiaHanCongViec extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };

  render() {
    let props = this.props;

    return (
      <Modal
        {...props}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-pencil-circle"></i>
            </span>{" "}
            Gia hạn công việc
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form className="form tat-toan form-horizontal form-edit">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse196991"
                  className="card-header border-info"
                  href="#collapse196991"
                  aria-expanded="true"
                  aria-controls="collapse196991"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Người nhận việc</h3>
                  </a>
                </div>
                <div
                  id="collapse196991"
                  aria-labelledby="headingCollapse96991"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Mã công việc"
                                disabled="disabled"
                                value="CV201011-001"
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Nhân viên"
                                disabled="disabled"
                                value="Nguyễn Thị Thu Hằng"
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Liên quan đến hợp đồng"
                                disabled="disabled"
                                value="LN201402-001"
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Ngày bắt đầu</label>
                                <input
                                  type="text"
                                  className="form-control input-sm datepicker-default"
                                  value="15/10/2018"
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Ngày kết thúc</label>
                                <input
                                  type="text"
                                  className="form-control input-sm datepicker-default"
                                  value="20/10/2018"
                                />
                              </div>
                            </div>

                            <div className="col-md-4"></div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Tên công việc"
                                disabled="disabled"
                                value="Đi đòi nợ"
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-8">
                              <div className="form-group">
                                <label>Nội dung công việc</label>
                                <textarea
                                  rows="2"
                                  className="form-control input-sm"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="headingCollapse196881"
                  className="card-header border-info"
                  href="#collapse196881"
                  aria-expanded="true"
                  aria-controls="collapse196881"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Người giao việc</h3>
                  </a>
                </div>
                <div
                  id="collapse196881"
                  aria-labelledby="headingCollapse96881"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Người giao việc"
                                disabled="disabled"
                                value="Nguyễn Thanh Trúc"
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label for="projectinput2">Chức vụ</label>
                                <select
                                  className="selectBox form-control input-sm"
                                  disabled
                                >
                                  <option value="0">Chủ</option>
                                  <option value="4">Quản lý</option>
                                  <option value="5">Nhân viên</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <a className="btn btn-new-main btn-checknew" href={() => false}>
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Gia hạn
          </a>

          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default GiaHanCongViec;
